import React from 'react'
import PropTypes from 'prop-types'
import { Box, Typography } from '@mui/material'
import { Label } from '../../../../components/styled/global.style'
import {
  AutocompleteStyle,
  FormError,
  InputBaseStyle,
  TextFieldModalStyle,
  TextFieldStyle
} from '../../Trade.style'
import { OptionContainer } from '../../Trade.style'
import FlagCurrency from '../../../../components/FlagCurrency/FlagCurrency'
import CurrencyLogo from '../../../../components/CurrencyLogo/CurrencyLogo'
import SelectWithArrow from '../../../../components/SelectWithArrow/SelectWithArrow'
import PaperAutoComplete from '../../../../components/PaperAutoComplete/PaperAutoComplete'

const DoubleNoTouchOptionTrade = ({
  form,
  handelFormChange,
  handelDateChange,
  currencyData,
  barrierDirectionData,
  currencyInitial,
  disabled = false,
  errors
}) => {
  return (
    <>
      <Box width={'100%'}>
        <Label>Spot Ref *</Label>
        <InputBaseStyle
          name="spot_ref"
          placeholder="0.00"
          value={form.spot_ref}
          onChange={handelFormChange}
          disabled={disabled}
        />
      </Box>
      <Box width={'100%'}>
        <Label>Payout Amount *</Label>
        <TextFieldStyle
          type="text"
          variant="outlined"
          name="payout_amount"
          placeholder="0.00"
          disabled={disabled}
          onChange={handelFormChange}
          value={form.payout_amount}
        />
      </Box>
      <Box width={'100%'}>
        <Label>Payout Currency *</Label>
        {Array.isArray(currencyData.data) && (
          <AutocompleteStyle
            onChange={(event, element) => {
              event.target.name = 'payout_currency'
              element = element ?? currencyInitial
              handelFormChange(event, element)
            }}
            size={'small'}
            value={form.payout_currency}
            getOptionLabel={option => option.name}
            options={currencyData.data}
            renderInput={params => (
              <TextFieldModalStyle
                {...params}
                fullWidth
                placeholder="Select Currency"
                disabled={disabled}
              />
            )}
            disabled={disabled}
            renderOption={(props, option) => (
              <OptionContainer {...props} key={option.id}>
                <FlagCurrency countryCode={option.code3} />
                <CurrencyLogo currencyCode={option.name} />
                <Typography style={{ marginLeft: 'auto' }}>{option.name} </Typography>
              </OptionContainer>
            )}
            ListboxComponent={PaperAutoComplete}
          />
        )}
      </Box>
      <Box width={'100%'}>
        <Label>Lower Barrier *</Label>
        <InputBaseStyle
          name="lower_barrier"
          placeholder="0.00"
          disabled={disabled}
          value={form.lower_barrier}
          onChange={handelFormChange}
        />
      </Box>
      <Box width={'100%'}>
        <Label>Window Start *</Label>
        <TextFieldStyle
          type="date"
          variant="outlined"
          value={form.window_start}
          myerror={String(!!errors.window_start)}
          disabled={disabled}
          onChange={event => handelDateChange('window_start', event.target.value)}
        />
        {errors.window_start && <FormError>{errors.window_start}</FormError>}
      </Box>
      <Box width={'100%'}>
        <Label>Window End *</Label>
        <TextFieldStyle
          type="date"
          variant="outlined"
          value={form.window_end}
          disabled={disabled}
          onChange={event => handelDateChange('window_end', event.target.value)}
        />
      </Box>

      <Box width={'100%'}>
        <Label>Upper Barrier *</Label>
        <InputBaseStyle
          name="upper_barrier"
          placeholder="0.00"
          value={form.upper_barrier}
          onChange={handelFormChange}
          disabled={disabled}
        />
      </Box>

      <Box width={'100%'}>
        <Label>Timing *</Label>
        <SelectWithArrow
          name="timing"
          placeholder="Select Timing"
          orderType={form.timing}
          onChange={handelFormChange}
          disabled={disabled}
          background="#39393C"
          items={[{ name: 'SETTLEMENT' }, { name: 'EXPIRY' }]}
        />
      </Box>
      <Box width={'100%'}>
        <Label>Barrier Direction</Label>
        {Array.isArray(barrierDirectionData.data) && (
          <AutocompleteStyle
            onChange={(event, element) => {
              event.target.name = 'barrier_direction'
              element = element ?? ''
              handelFormChange(event, element)
            }}
            size={'small'}
            value={form.barrier_direction}
            getOptionLabel={option => option}
            options={barrierDirectionData.data.map(({ name }) => name)}
            renderInput={params => (
              <TextFieldModalStyle {...params} fullWidth placeholder="Select Barrier Direction" />
            )}
            ListboxComponent={PaperAutoComplete}
          />
        )}
      </Box>
    </>
  )
}

export default DoubleNoTouchOptionTrade

DoubleNoTouchOptionTrade.propTypes = {
  disabled: PropTypes.bool,
  currencyData: PropTypes.object,
  currencyInitial: PropTypes.object,
  handelFormChange: PropTypes.func,
  handelDateChange: PropTypes.func,
  barrierDirectionData: PropTypes.object,
  form: PropTypes.object,
  errors: PropTypes.object
}
